import { render, staticRenderFns } from "./EnerIqEconomicUnitTable.global.vue?vue&type=template&id=22d127a8&lang=pug&"
import script from "./EnerIqEconomicUnitTable.global.vue?vue&type=script&lang=ts&"
export * from "./EnerIqEconomicUnitTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports